
import React, { useState } from 'react';

const HomePage: React.FC = () => {
  const [selectedService, setSelectedService] = useState('');
  const [showPhonePopup, setShowPhonePopup] = useState(false);
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const news = [
    { date: '2025.8.1', content: '営業時間変更のお知らせ\n8月1日よりカットの受付時間を19時までに変更致します。' },
    { date: '2025.7.14', content: '料金改定のお知らせ\nいつもご来店頂きありがとうございます。光熱費、材料費などの値上がりを踏まえR7 7月1日より一部料金を改定させて頂きます。' },
    { date: '2024.9.9', content: '臨時休業のお知らせ\n誠に勝手ながら11月10日(日)は臨時休業とさせて頂きます。' }
  ];

  const toggleAccordion = (section: string) => {
    setOpenAccordion(openAccordion === section ? null : section);
  };

  const showPhoneDialog = () => {
    setShowPhonePopup(true);
  };

  return (
    <div className="min-h-screen">
      {/* ヒーローセクション */}
      <section 
        className="relative w-full h-screen flex items-center justify-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://static.readdy.ai/image/8677bad59e2a8d42d078f4758e05323e/6d91f236d1d6ddf109e6af3acac239f2.jpeg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
            MiZ
          </h1>
          <h2 className="text-3xl md:text-5xl font-light mb-8">
            美容室ミゼット
          </h2>
          <p className="text-xl md:text-2xl mb-12 leading-relaxed">
            <span className="hidden md:inline">守谷で1998年にオープンしました。真心込めて一人一人のお客様に<br />ゆったりと癒しの空間をお届けします</span>
            <span className="md:hidden">守谷で1998年にオープンしました。真心込めて一人一人のお客様にゆったりと癒しの空間をお届けします</span>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={showPhoneDialog}
              className="bg-orange-400 hover:bg-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              ご予約はこちら
            </button>
            <a
              href="tel:0297-46-1606"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-800 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              0297-46-1606
            </a>
          </div>
        </div>
      </section>

      {/* サロン紹介セクション */}
      <section className="py-20 px-4 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">
                Welcome to <span className="text-orange-500">MiZ</span> Homepage
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  美容室ミゼットは守谷で1998年にオープンしました。
                </p>
                <p className="text-orange-600 font-semibold">
                  申し訳ありません…
                </p>
                <p>
                  スタッフ2人でやっておりますので、大きなサロンのようにたくさんのお客様の対応は出来ません。
                </p>
                <p className="text-orange-600 font-semibold">
                  しかし…
                </p>
                <p>
                  アットホームな雰囲気の中で、真心こめて1人1人のお客様に対応させて頂きたいと心掛けています。
                  ゆったりと癒しの空間を提供出来たら…と思っています。
                </p>
                <p>
                  ご来店お待ちしております。予約優先でやっておりますので、お電話にてご予約して頂けますようお願い致します。
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/8677bad59e2a8d42d078f4758e05323e/4ce42c10f4ef7ba619bf18cbe043cfc4.jpeg"
                alt="守谷の美容室ミゼット店舗写真"
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 詳細メニュー・料金表セクション */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">
            詳細メニュー・料金表
          </h2>

          {/* デスクトップ表示 */}
          <div className="hidden md:block">
            {/* カット */}
            <div className="mb-12 bg-orange-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-orange-600 mb-6 flex items-center">
                <i className="ri-scissors-line mr-3"></i>
                カット（シャンプー・ブロー付）
              </h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">一般</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥4,950〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥4,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">高校生</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥4,180</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥3,800</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">中学生</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥3,850</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥3,500</div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">小学生</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥3,300</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥3,000</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">子供（シャンプーなし）</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥2,750</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥2,500</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">部分カット</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥1,100</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥1,100</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* パーマ */}
            <div className="mb-12 bg-orange-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-orange-600 mb-6 flex items-center">
                <i className="ri-magic-line mr-3"></i>
                パーマ（シャンプー・カット・ブロー付）
              </h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">部分</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥7,700〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥7,000〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">全体</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥10,450〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥9,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">ストレート</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥12,100〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥11,000〜</div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">縮毛矯正</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥23,650〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥18,100〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">デジタルパーマ</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥16,500〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥15,000〜</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-amber-50 border border-amber-200 rounded-lg p-4">
                <p className="text-sm text-amber-800">
                  <i className="ri-information-line mr-2"></i>
                  ※1 全体・ストレート セミロング+¥1,000UP ロング+¥2,000UP<br />
                  ※2 縮毛矯正 セミロング+¥2,000UP ロング+¥4,000UP
                </p>
              </div>
            </div>

            {/* カラー */}
            <div className="mb-12 bg-orange-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-orange-600 mb-6 flex items-center">
                <i className="ri-palette-line mr-3"></i>
                カラー（シャンプー・ブロー付）
              </h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <div>
                    <span className="font-medium">グレーカラー</span>
                    <div className="text-sm text-gray-600">（白髪染め）（リタッチ・ワンタッチ）</div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-bold">¥6,050〜</div>
                    <div className="text-sm text-orange-600">メンバーズ ¥5,500〜</div>
                  </div>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <div>
                    <span className="font-medium">ファッションカラー</span>
                    <div className="text-sm text-gray-600">（おしゃれ染め）（リタッチ・ワンタッチ）</div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-bold">¥8,030〜</div>
                    <div className="text-sm text-orange-600">メンバーズ ¥7,300〜</div>
                  </div>
                </div>
              </div>
            </div>

            {/* セット */}
            <div className="mb-12 bg-orange-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-orange-600 mb-6 flex items-center">
                <i className="ri-star-line mr-3"></i>
                セット
              </h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <span className="font-medium">セット</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥6,050〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥5,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <div>
                      <span className="font-medium">成人式</span>
                      <div className="text-sm text-gray-600">（着付・セット）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥27,500</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <div>
                      <span className="font-medium">七五三 三才</span>
                      <div className="text-sm text-gray-600">（着付・セット）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥17,600</div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <div>
                      <span className="font-medium">五才</span>
                      <div className="text-sm text-gray-600">（着付のみ）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥11,550</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-orange-200">
                    <div>
                      <span className="font-medium">七才</span>
                      <div className="text-sm text-gray-600">（着付・セット）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥22,000</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 着付け */}
            <div className="mb-12 bg-orange-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-orange-600 mb-6 flex items-center">
                <i className="ri-shirt-line mr-3"></i>
                着付け
              </h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="font-medium">留袖</span>
                  <div className="text-right">
                    <div className="text-lg font-bold">¥9,900</div>
                  </div>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="font-medium">振袖</span>
                  <div className="text-right">
                    <div className="text-lg font-bold">¥13,200</div>
                  </div>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="font-medium">卒業式袴（はかま）</span>
                  <div className="text-right">
                    <div className="text-lg font-bold">¥9,460</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* スマホ表示（アコーディオン） */}
          <div className="md:hidden space-y-4">
            {/* カット */}
            <div className="bg-orange-50 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion('cut')}
                className="w-full p-4 text-left flex justify-between items-center bg-orange-400 text-white cursor-pointer"
              >
                <div className="flex items-center">
                  <i className="ri-scissors-line mr-3"></i>
                  <span className="font-bold">カット（シャンプー・ブロー付）</span>
                </div>
                <i className={`ri-arrow-${openAccordion === 'cut' ? 'up' : 'down'}-s-line text-xl`}></i>
              </button>
              {openAccordion === 'cut' && (
                <div className="p-4 space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">一般</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥4,950〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥4,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">高校生</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥4,180</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥3,800</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">中学生</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥3,850</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥3,500</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">小学生</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥3,300</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥3,000</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">子供（シャンプーなし）</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥2,750</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥2,500</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">部分カット</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥1,100</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥1,100</div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* パーマ */}
            <div className="bg-orange-50 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion('perm')}
                className="w-full p-4 text-left flex justify-between items-center bg-orange-400 text-white cursor-pointer"
              >
                <div className="flex items-center">
                  <i className="ri-magic-line mr-3"></i>
                  <span className="font-bold">パーマ（シャンプー・カット・ブロー付）</span>
                </div>
                <i className={`ri-arrow-${openAccordion === 'perm' ? 'up' : 'down'}-s-line text-xl`}></i>
              </button>
              {openAccordion === 'perm' && (
                <div className="p-4 space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">部分</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥7,700〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥7,000〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">全体</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥10,450〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥9,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">ストレート</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥12,100〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥11,000〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">縮毛矯正</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥23,650〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥18,100〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">デジタルパーマ</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥16,500〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥15,000〜</div>
                    </div>
                  </div>
                  <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-3">
                    <p className="text-sm text-amber-800">
                      <i className="ri-information-line mr-2"></i>
                      ※1 全体・ストレート セミロング+¥1,000UP ロング+¥2,000UP<br />
                      ※2 縮毛矯正 セミロング+¥2,000UP ロング+¥4,000UP
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* カラー */}
            <div className="bg-orange-50 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion('color')}
                className="w-full p-4 text-left flex justify-between items-center bg-orange-400 text-white cursor-pointer"
              >
                <div className="flex items-center">
                  <i className="ri-palette-line mr-3"></i>
                  <span className="font-bold">カラー（シャンプー・ブロー付）</span>
                </div>
                <i className={`ri-arrow-${openAccordion === 'color' ? 'up' : 'down'}-s-line text-xl`}></i>
              </button>
              {openAccordion === 'color' && (
                <div className="p-4 space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <div>
                      <span className="font-medium">グレーカラー</span>
                      <div className="text-sm text-gray-600">（白髪染め）（リタッチ・ワンタッチ）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥6,050〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥5,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <div>
                      <span className="font-medium">ファッションカラー</span>
                      <div className="text-sm text-gray-600">（おしゃれ染め）（リタッチ・ワンタッチ）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥8,030〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥7,300〜</div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* セット */}
            <div className="bg-orange-50 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion('set')}
                className="w-full p-4 text-left flex justify-between items-center bg-orange-400 text-white cursor-pointer"
              >
                <div className="flex items-center">
                  <i className="ri-star-line mr-3"></i>
                  <span className="font-bold">セット</span>
                </div>
                <i className={`ri-arrow-${openAccordion === 'set' ? 'up' : 'down'}-s-line text-xl`}></i>
              </button>
              {openAccordion === 'set' && (
                <div className="p-4 space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">セット</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥6,050〜</div>
                      <div className="text-sm text-orange-600">メンバーズ ¥5,500〜</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <div>
                      <span className="font-medium">成人式</span>
                      <div className="text-sm text-gray-600">（着付・セット）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥27,500</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <div>
                      <span className="font-medium">七五三 三才</span>
                      <div className="text-sm text-gray-600">（着付・セット）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥17,600</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <div>
                      <span className="font-medium">五才</span>
                      <div className="text-sm text-gray-600">（着付のみ）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥11,550</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <div>
                      <span className="font-medium">七才</span>
                      <div className="text-sm text-gray-600">（着付・セット）</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥22,000</div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* 着付け */}
            <div className="bg-orange-50 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion('kimono')}
                className="w-full p-4 text-left flex justify-between items-center bg-orange-400 text-white cursor-pointer"
              >
                <div className="flex items-center">
                  <i className="ri-shirt-line mr-3"></i>
                  <span className="font-bold">着付け</span>
                </div>
                <i className={`ri-arrow-${openAccordion === 'kimono' ? 'up' : 'down'}-s-line text-xl`}></i>
              </button>
              {openAccordion === 'kimono' && (
                <div className="p-4 space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">留袖</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥9,900</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">振袖</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥13,200</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-orange-200">
                    <span className="font-medium">卒業式袴（はかま）</span>
                    <div className="text-right">
                      <div className="text-lg font-bold">¥9,460</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="bg-orange-100 border-l-4 border-orange-500 p-6 rounded-lg inline-block">
              <h3 className="text-xl font-bold text-orange-800 mb-2">
                <i className="ri-vip-crown-line mr-2"></i>
                メンバーズ特典
              </h3>
              <p className="text-orange-700 text-lg">
                メンバーズカードをお持ちの方は特別料金でご利用いただけます
              </p>
            </div>

            <div className="bg-amber-100 border-l-4 border-amber-500 p-6 rounded-lg inline-block mt-6">
              <h3 className="text-xl font-bold text-amber-800 mb-2">
                <i className="ri-coupon-line mr-2"></i>
                新規のお客様限定クーポン
              </h3>
              <p className="text-amber-700 text-lg">
                技術料金 <span className="text-2xl font-bold">20%OFF</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* お知らせセクション */}
      <section className="py-20 bg-orange-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">
            What's New / キャンペーン情報
          </h2>
          <div className="space-y-6">
            {news.map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6 border-l-4 border-orange-500">
                <div className="flex flex-col md:flex-row md:items-start gap-4">
                  <div className="text-orange-600 font-bold text-lg whitespace-nowrap">
                    {item.date}
                  </div>
                  <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                    {item.content}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* カレンダーセクション */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">
            MiZ カレンダー
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">10月カレンダー</h3>
              <iframe
                src="https://www.google.com/calendar/embed?showTitle=0&showNav=0&showDate=0&showPrint=0&showTabs=0&showCalendars=0&showTz=0&height=300&wkst=1&bgcolor=%23FFFFFF&src=mizsalon%40gmail.com&color=%232952A3&ctz=Asia%2FTokyo"
                className="w-full h-80 border-0 rounded"
                scrolling="no"
                title="October Calendar"
              />
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">11月カレンダー</h3>
              <iframe
                src="https://www.google.com/calendar/embed?showTitle=0&showNav=0&showDate=0&showPrint=0&showTabs=0&showCalendars=0&showTz=0&height=300&wkst=1&bgcolor=%23FFFFFF&src=mizsalon%40gmail.com&color=%232952A3&ctz=Asia%2FTokyo&dates=20251101/20251102"
                className="w-full h-80 border-0 rounded"
                scrolling="no"
                title="November Calendar"
              />
            </div>
          </div>
        </div>
      </section>

      {/* アクセス情報セクション */}
      <section className="py-20 bg-orange-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">
            アクセス・店舗情報
          </h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-6">
              <div className="bg-white rounded-lg shadow-lg p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                  <i className="ri-map-pin-line text-orange-500 mr-2"></i>
                  店舗情報
                </h3>
                <div className="space-y-3 text-gray-700">
                  <p><strong>店名:</strong> 美容室ミゼット MiZ</p>
                  <p><strong>住所:</strong> 茨城県守谷市松ヶ丘7-1-5</p>
                  <p><strong>TEL/FAX:</strong> <a href="tel:0297-46-1606" className="text-orange-500 hover:underline cursor-pointer">0297-46-1606</a></p>
                  <div className="space-y-2">
                    <p><strong>営業時間:</strong></p>
                    <div className="ml-4 space-y-1 text-sm">
                      <p>平日　AM9:00～PM7:00（カット）</p>
                      <p className="ml-8">PM6:30（パーマ・カラー）</p>
                      <p>日祝　AM9:00～PM7:00（カット）</p>
                      <p className="ml-8">PM5:30（パーマ・カラー）</p>
                    </div>
                  </div>
                  <p><strong>定休日:</strong> 毎週火曜日、第２・第３月曜日</p>
                  <p><strong>駐車場:</strong> 店舗の裏にございます</p>
                  <p className="text-sm text-gray-600">※空車がない時はスタッフまでお伝えください</p>
                </div>
              </div>
              <div className="bg-orange-50 rounded-lg p-6">
                <h3 className="text-lg font-bold text-orange-800 mb-3">
                  <i className="ri-information-line mr-2"></i>
                  ご予約について
                </h3>
                <p className="text-orange-700">
                  予約優先制となっております。お電話でご予約をお願いいたします。
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12921.09391286556!2d139.96235221624377!3d35.94027938835434!2m3!1f0!1f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189e5e7e9a40bf%3A0xc51b874f3e08c97b!2z576O5a655a6k44Of44K844OD44OI!5e0!3m2!1sja!2sjp!4v1761355389632!5m2!1sja!2sjp"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="美容室ミゼット地図"
              />
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4 text-orange-400" style={{ fontFamily: '"Pacifico", serif' }}>
                MiZ
              </h3>
              <p className="text-gray-300 mb-4">
                美容室ミゼット<br />
                守谷で1998年にオープンしました。真心込めたサービスをお届けします。
              </p>
              <div className="flex space-x-4">
                <button
                  onClick={showPhoneDialog}
                  className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg text-sm transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
                >
                  ご予約
                </button>
                <button
                  onClick={showPhoneDialog}
                  className="bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded-lg text-sm transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer text-white border border-gray-600 shadow-lg"
                >
                  お問い合わせ
                </button>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-orange-400">営業時間</h4>
              <div className="text-gray-300 space-y-2 text-sm">
                <p>平日　AM9:00～PM7:00（カット）</p>
                <p className="ml-4">PM6:30（パーマ・カラー）</p>
                <p>日祝　AM9:00～PM7:00（カット）</p>
                <p className="ml-4">PM5:30（パーマ・カラー）</p>
                <p className="mt-5"><strong className="text-white">定休日:</strong> 毎週火曜日、第２・第３月曜日</p>
                <p className="text-orange-300">予約優先制</p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-orange-400">お問い合わせ</h4>
              <div className="text-gray-300 space-y-2">
                <p>
                  <i className="ri-phone-line mr-2 text-orange-400"></i>
                  <a href="tel:0297-46-1606" className="hover:text-orange-400 transition-colors">0297-46-1606</a>
                </p>
                <p>
                  <i className="ri-map-pin-line mr-2 text-orange-400"></i>
                  茨城県守谷市松ヶ丘7-1-5
                </p>
                <p className="text-sm">店舗の裏に駐車場がございます</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 美容室ミゼット MiZ. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* 電話ポップアップモーダル */}
      {showPhonePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-sm w-full">
            <div className="p-6 text-center">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold text-gray-800">お電話でのご予約・お問い合わせ</h3>
                <button
                  onClick={() => setShowPhonePopup(false)}
                  className="text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <div className="mb-6">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-orange-500"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">美容室ミゼット</h4>
                <p className="text-gray-600 mb-4">お気軽にお電話ください</p>

                <div className="bg-orange-50 rounded-lg p-4 mb-4">
                  <p className="text-3xl font-bold text-orange-600 mb-2">0297-46-1606</p>
                  <div className="text-sm text-gray-600 space-y-1">
                    <p>平日　AM9:00～PM7:00（カット）</p>
                    <p className="ml-6">PM6:30（パーマ・カラー）</p>
                    <p>日祝　AM9:00～PM7:00（カット）</p>
                    <p className="ml-6">PM5:30（パーマ・カラー）</p>
                    <p className="mt-2"><strong className="text-white">定休日:</strong> 毎週火曜日、第２・第３月曜日</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
